(function() {
  'use strict';

  var ListPermissionCtrlBulk = function($scope, ajaxCall) {

    console.log("Inside ListPermissionCtrlBulk");
    $scope.listPermModel = {};
    $scope.listPermModel.showLoader = false;
    $scope.listPermModel.disableBtn = false;
    $scope.listPermModel.usersInTable = [];
    $scope.listPermModel.messageType = 'success';

    var ajaxCallList = function(ajaxUrl, data) {

      var errorMsg = 'Error';
      ajaxCall.getData(ajaxUrl, data).then(
        function(result) {
          $scope.listPermModel.showLoader = false;
          $scope.listPermModel.disableBtn = false;
          $scope.listPermModel.messagePerm = result.data;
          $scope.listPermModel.messageType = 'success'
        },
        function(result) {
          $scope.listPermModel.showLoader = false;
          $scope.listPermModel.disableBtn = false;
          $scope.listPermModel.messagePerm = errorMsg;
        }
      );
    }

    $scope.deletePermissionBulkNg = function($event) {
      $event.preventDefault();
      $scope.listPermModel.showLoader = true;
      $scope.listPermModel.disableBtn = true;
      var userOwner = $scope.listPermModel.userOwner;
      var tagIdList = []
      for (var listId in userOwner) {
        tagIdList.push(listId)
      }

      if (tagIdList) {
        var data = 'tagId=' + tagIdList;
        var ajaxUrl = WEBAPP_PATH + "/tagAdmin/deletePermissionsBulk?";
        var errorMsg = 'Error';
        ajaxCall.getData(ajaxUrl, data).then(
          function(result) {
            $scope.listPermModel.tableModel = [];
            $scope.listPermModel.tableBranchModel = [];
            $scope.listPermModel.tableModel.userOptions = $scope.listPermModel.userOptions;
            $scope.listPermModel.tableModel.userRightsOptions = $scope.listPermModel.userRightsOptions;
            $scope.listPermModel.tableBranchModel.orgUnitsJson = $scope.listPermModel.orgUnitsJson;
            $scope.listPermModel.tableBranchModel.userRightsOptions = $scope.listPermModel.userRightsOptions;
            $scope.listPermModel.messagePerm = result.data;
            $scope.listPermModel.messageType = 'success'
            $scope.listPermModel.showLoader = false;
            $scope.listPermModel.disableBtn = false;
          },
          function(result) {
            $scope.listPermModel.showLoader = false;
            $scope.listPermModel.disableBtn = false;
            $scope.listPermModel.messagePerm = errorMsg;
          }
        );
      }
      return false;
    }

    $scope.cancel = function() {
      $scope.ok();
    };

    $scope.tagPermissionSubmitNg = function($event) {
      $event.preventDefault();

      var userOwner = $scope.listPermModel.userOwner;
      var tableData;

      var userPermissionArray = [];
      var ouPermissionArray = [];

      var userOwnerArray = []
      var tagIdList = []

      for (var listId in userOwner) {
        var usersInTable = []
        var userOwnerMap = {};
        var listOwner = userOwner[listId];
        userOwnerMap['listId'] = listId;
        userOwnerMap['userId'] = listOwner;
        userOwnerArray.push(userOwnerMap);
        tagIdList.push(listId);

        var tableModel = $scope.listPermModel.tableModel[listId];

          for (i = 0; i < tableModel.length; i++) {
            tableData = tableModel[i];

            if (!angular.toJson(tableModel[i]).includes('userSelect') || !angular.toJson(tableModel[i]).includes('userRightsSelect')) {
              $scope.listPermModel.messagePerm = "User or permission type cannot be blank"
              $scope.listPermModel.messageType = 'danger'
              return false;
            } else if (usersInTable.length > 0 && usersInTable.includes(tableData.userSelect.xmsLoginId)) {
              $scope.listPermModel.messagePerm = "The action cannot be saved as multiple rows have the same user id."
              $scope.listPermModel.messageType = 'danger'
              return false;
            } else {
              var userPermissionMap = {};
              userPermissionMap['listId'] = listId;
              userPermissionMap['userId'] = tableData.userSelect.xmsLoginId;
              userPermissionMap['userRightId'] = tableData.userRightsSelect.id;
              userPermissionArray.push(userPermissionMap);
              usersInTable.push(tableData.userSelect.xmsLoginId);
            }
          }

        var OUsInTable = []
        var tableBranchModel = $scope.listPermModel.tableBranchModel[listId];
          for(i=0;i<tableBranchModel.length;i++){
            tableData = tableBranchModel[i];

            if (!angular.toJson(tableBranchModel[i]).includes('orgUnitSelect') || !angular.toJson(tableBranchModel[i]).includes('userRightsSelect')) {
              $scope.listPermModel.messagePerm = "OU or permission type cannot be blank"
              $scope.listPermModel.messageType = 'danger'
              return false;
            } else if(OUsInTable.length > 0 && OUsInTable.includes(tableData.orgUnitSelect.id)){
              $scope.listPermModel.messagePerm =  "The action cannot be saved as multiple rows have the same OU id."
              $scope.listPermModel.messageType = 'danger'
              return false;
            }else{
              var ouPermissionMap = {};
              ouPermissionMap['listId'] = listId;
              ouPermissionMap['ouId'] = tableData.orgUnitSelect.id;
              ouPermissionMap['ouRightId'] = tableData.userRightsSelect.id;
              ouPermissionArray.push(ouPermissionMap);
              OUsInTable.push(tableData.orgUnitSelect.id);
            }
          }
      }

      var data = 'userPermissionArray=' + angular.toJson(userPermissionArray) + '&ouPermissionArray=' + angular.toJson(ouPermissionArray);
      data = data + '&userOwnerArray=' + angular.toJson(userOwnerArray) + '&tagIdList=' + angular.toJson(tagIdList);

      var ajaxUrl = WEBAPP_PATH + "/tagAdmin/updatePermissionsBulk";

      ajaxCallList(ajaxUrl , data);

      return false;
    }

  }
  ListPermissionCtrlBulk.$inject = ['$scope', 'ajaxCall'];
  angular.module('app').controller('ListPermissionCtrlBulk', ListPermissionCtrlBulk);

}());
